module.exports = __webpack_public_path__ + "img/star1.8d2a3054.svg";